<input class="position-absolute string-input-style" #scorableInput [ngStyle]="{ 
    'text-align': this.textAlignment,
    'background-color': backgroundColor,
    'border-color': borderColor,
    }" />